import { IconButton, useToken } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";

const hexToRgba = (hex, alpha) => {
  if (!hex || hex.length < 4) return `rgba(59, 130, 246, ${alpha})`;
  const clean = hex.startsWith("#") ? hex.slice(1) : hex;
  if (clean.length < 6) return `rgba(59, 130, 246, ${alpha})`;
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const GlassIconButton = ({
  children,
  colorScheme = "blue",
  "aria-label": ariaLabel,
  ...rest
}) => {
  const reduceMotion = useReducedMotion();
  const isHex =
    typeof colorScheme === "string" && colorScheme.startsWith("#");
  const [tokenBase] = useToken("colors", [
    !isHex ? `${colorScheme}.500` : "transparent",
  ]);
  const baseColor = isHex ? colorScheme : tokenBase || "#3b82f6";

  return (
    <IconButton
      as={motion.button}
      whileHover={reduceMotion ? undefined : { scale: 1.06 }}
      whileTap={reduceMotion ? undefined : { scale: 0.94 }}
      transition={{ type: "spring", stiffness: 380, damping: 22 }}
      aria-label={ariaLabel}
      variant="unstyled"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      minW="40px"
      minH="40px"
      w="40px"
      h="40px"
      p={0}
      color="white"
      borderRadius="full"
      bg={hexToRgba(baseColor, 0.82)}
      border="1px solid"
      borderColor="whiteAlpha.500"
      backdropFilter="blur(12px)"
      boxShadow={`0 6px 16px ${hexToRgba(baseColor, 0.35)}`}
      _hover={{ bg: hexToRgba(baseColor, 0.95) }}
      _focusVisible={{ boxShadow: "focus" }}
      {...rest}
    >
      {children}
    </IconButton>
  );
};

export default GlassIconButton;
